import React from 'react';

const SourceFilter = ({ value, onChange }) => {
  // Static services array
  const services = [
    { label: "Offline", value: "offline" },
    { label: "Online", value: "online" },
    { label: "Labs", value: "labs" },
    { label: "Pharmacy", value: "pharmacy" },
    { label: "Reimbursement", value: "reimbursement" },
    { label: "Dental", value: "dental" },
    { label: "Vaccination", value: "vaccination" },
    { label: "Digitisation", value: "digitisation" },
  ];

  return (
    <select
      style={{
        width: '100%',
        fontSize: '12px',
        borderRadius: '10px',
        height: '32px',
      }}
      onChange={(e) => onChange(e.target.value)}
      value={value}
    >
      <option value="">All</option>
      {services.map((service) => (
        <option key={service.value} value={service.value}>
          {service.label}
        </option>
      ))}
    </select>
  );
};


export default SourceFilter;
